module.exports = __webpack_public_path__ + "img/upload-folder.397c72b8.svg";